export default {
  slider: {
    sliderConfig: {
      autoplay: true,
      autoplaySpeed: 3000,
      timing: 'linear',
      centerMode: false,
      slidesToShow: 3,
      loop: true,
      dots: false,
      responsive: [
        {
          breakpoint: 300,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 3
          }
        }
      ]
    }
  },
  website: {
    imageBaseURL: 'https://ardunic-images.s3.eu-central-1.amazonaws.com/'
  }
}
